export default __webpack_public_path__ + "static/media/booksun.0de261e2.svg";